import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/internal/Observable";
import { Option } from "../../models/themes/option.model";import { StyleManagerService } from "./style-manager.service";


 
@Injectable()
export class ThemeService {
  constructor(
    private http: HttpClient,
    private styleManager: StyleManagerService
  ) {}
 
  getThemeOptions(): Observable<Array<Option>> {
    return this.http.get<Array<Option>>("assets/theme/options.json");
  }
 
  setTheme(themeToSet: string) {
    // console.log("Set theme");
    this.styleManager.setStyle(
      "theme",
      `node_modules/@angular/material/prebuilt-themes/${themeToSet}.css`
    );
  }
}